
import * as Yup from 'yup';
import React, { Component } from 'react'
import { FormGroup } from 'reactstrap';
import { Form, Field, Formik, ErrorMessage } from 'formik';
import handleSubmit from './handleSubmit';
export default class LoginForm extends Component {
  validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().required('Password is required')
  })
  render() {
    return (
      <Formik
        initialValues={{ email: "", password: "" }}
        onSubmit={handleSubmit}
        validationSchema={this.validationSchema}
      >
        {() => (<Form className="form-container">
          <FormGroup>
            <Field type="text" name="email" className={"form-control"} placeholder="Email" />
            <ErrorMessage style={{ color: "red" }} component="div" name='email' />
          </FormGroup>
          <FormGroup>
            <Field type="password" name="password" className={"form-control"} placeholder="Password" />
            <ErrorMessage style={{ color: "red" }} component="div" name='password' /> </FormGroup>
          <button type="submit" className="btn btn-primary mt-2">Submit</button>
        </Form>)}
      </Formik>
    )
  }
}
